import { Box } from "@chakra-ui/react";
import { phoneFormatter } from "../../../../../shared/utils/phone-formatter";
import { entityProfileModalColors } from "../../../../entityProfileModal/entityProfileModal.theme";
import type { PatientProfilePatient } from "../../../patientProfileModal.types";
import type { AddressDraft, PatientAddress } from "./addresses.types";

export const emptyAddressDraft: AddressDraft = {
  address: "",
  address2: null,
  description: null,
  evvLocation: "HOME",
  phoneNumberIds: [],
};

export const requiredIndicator = (
  <Box as="span" color={entityProfileModalColors.danger}>
    *
  </Box>
);

export function formatEvvLocation(value: PatientAddress["evvLocation"]) {
  switch (value) {
    case "HOME":
      return "Home";
    case "COMMUNITY":
      return "Community";
  }
}

export function formatPhoneNumberLabel(phoneNumber: PatientProfilePatient["phoneNumbers"][number]) {
  switch (phoneNumber.type) {
    case "TEL":
      return "Home phone";
    case "MOBILE":
      return "Mobile phone";
    case "OTHER":
      return phoneNumber.label ?? "Other";
  }
}

export function getPhoneNumberDisplay(phoneNumber: PatientProfilePatient["phoneNumbers"][number]) {
  return phoneFormatter.formatNationalIfValid(phoneNumber.phonenumber);
}

export function normalizeAddressDraft(draft: AddressDraft) {
  return {
    address: draft.address.trim(),
    address2: draft.address2?.trim() || null,
    description: draft.description?.trim() || null,
    evvLocation: draft.evvLocation,
    phoneNumberIds: draft.phoneNumberIds,
  };
}

export function getAddressDraftKey(draft: AddressDraft) {
  return draft.id === undefined ? "new" : String(draft.id);
}
